// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ecclesiasticus (Sirach)",
  bookSlug: "ecclesiasticus",
  chapter: 25,
  argument: "Documents of wisdom on several subjects.",
  verses: [
    { n: 1, text: "With three things my spirit is pleased, which are approved before God and men:" },
    { n: 2, text: "The concord of brethren, and the love of neighbours, and man and wife that agree well together." },
    { n: 3, text: "Three sorts my soul hateth, and I am greatly grieved at their life:" },
    { n: 4, text: "A poor man that is proud: a rich man that is a liar: an old man that is a fool, and doting." },
    { n: 5, text: "The things that thou hast not gathered in thy youth, how shalt thou find them in thy old age?" },
    { n: 6, text: "O how comely is judgment for a grey head, and for ancients to know counsel!" },
    { n: 7, text: "O how comely is wisdom for the aged, and understanding and counsel to men of honour!" },
    { n: 8, text: "Much experience is the crown of old men, and the fear of God is their glory." },
    { n: 9, text: "Nine things that are not to be imagined by the heart have I magnified, and the tenth I will utter to men with my tongue." },
    { n: 10, text: "A man that hath joy of his children: and he that liveth and seeth the fall of his enemies." },
    { n: 11, text: "Blessed is he. that dwelleth with a wise woman, and that hath not slipped with his tongue, and that hath not served such as are unworthy of him." },
    { n: 12, text: "Blessed is he that findeth a true friend: and that declareth justice to an ear that heareth." },
    { n: 13, text: "How great is he that findeth wisdom and knowledge! but there is none above him that feareth the Lord." },
    { n: 14, text: "The fear of God hath set itself above all things:" },
    { n: 15, text: "Blessed is the man, to whom it is given to have the fear of God: he that holdeth it, to whom shall he be likened?" },
    { n: 16, text: "The fear of God is the beginning of his love: and the beginning of faith is to be fast joined unto it." },
    { n: 17, text: "The sadness of the heart is every plague: and the wickedness of a woman is all evil." },
    { n: 18, text: "And a man will choose any plague, but the plague of the heart:" },
    { n: 19, text: "And any wickedness, but the wickedness of a woman:" },
    { n: 20, text: "And any affliction, but the affliction from them that hate him:" },
    { n: 21, text: "And any revenge, but the revenge of enemies." },
    { n: 22, text: "There is no head worse than the head of a serpent:" },
    { n: 23, text: "And there is no anger above the anger of a woman. It will be more agreeable to abide with a lion and a dragon, than to dwell with a wicked woman." },
    { n: 24, text: "The wickedness of a woman changeth her face: and she darkeneth her countenance as a bear: and sheweth it like sackcloth. In the midst of her neighbours," },
    { n: 25, text: "Her husband groaned, and hearing, he sighed a little." },
    { n: 26, text: "All malice is short to the malice of a woman: let the lot of sinners fall upon her." },
    { n: 27, text: "As the climbing of a sandy way is to the feet of the aged, so is a wife full of tongue to a quiet man." },
    { n: 28, text: "Look not upon a woman's beauty, and desire not a woman for beauty." },
    { n: 29, text: "A woman's anger, and impudence, and confusion is great." },
    { n: 30, text: "A woman, if she have superiority, is contrary to her husband." },
    { n: 31, text: "A wicked woman abateth the courage, and maketh a heavy countenance and a wounded heart." },
    { n: 32, text: "Feeble hands, and disjointed knees, a woman that doth not make her husband happy." },
    { n: 33, text: "From the woman came the beginning of sin, and by her we all die." },
    { n: 34, text: "Give no issue to thy water, no, not a little: nor to a wicked woman liberty to gad abroad." },
    { n: 35, text: "If she walk not at thy hand, she will confound thee in the sight of thy enemies." },
    { n: 36, text: "Cut her off from thy flesh, lest she always abuse thee." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Pleased. Wisdom still speaks. Solomon often makes similar divisions, to make the deeper impression, Proverbs xxx. 15, 24.", attribution: "Haydock" }
    ] },
    { verse: 4, notes: [
      { text: "Fool. Greek, \"adulterer, devoid of sense,\" Isaias lxv. 20. (Calmet) — Luxuria....senectuti fœdissima.", attribution: "Cicero, off. i." }
    ] },
    { verse: 5, notes: [
      { text: "Age? Wisdom, says Bias, \"is more durable than other possessions.\"", attribution: "Laertius" }
    ] },
    { verse: 9, notes: [
      { text: "Things. Greek, \"nine suppositions I have blessed in my heart,\" (Haydock) or thought that they may confer felicity. B\\but the tenth will certainly do it, chap. xiv.", attribution: "Haydock" }
    ] },
    { verse: 10, notes: [
      { text: "Enemies. Not out of revenge, but for the glory of God. See Matthew v. 43.", attribution: "Haydock" }
    ] },
    { verse: 12, notes: [
      { text: "A true. Greek, \"prudence.\"", attribution: "Calmet" }
    ] },
    { verse: 14, notes: [
      { text: "Things. Greek adds, \"for light (15.) he that,\" &c.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "It. This is not in the edition of Rome, or of Aldus: but it is in the rest. Fear commonly begins the work of salvation, and love perfects it, 1 Timothy i. 5. (Calmet) — All happiness in this life is grounded on the fear of God.", attribution: "Worthington" }
    ] },
    { verse: 17, notes: [
      { text: "Evil. Greek reads not this; but the Syriac does, omitting the two next verses. (Calmet) — Heresy is described under the idea of a wicked woman, concealing her malice.", attribution: "Worthington" }
    ] },
    { verse: 18, notes: [
      { text: "Choose. Literally, \"see.\" (Haydock) — Some supply \"send any plague,\" &c.", attribution: "Haydock" }
    ] },
    { verse: 21, notes: [
      { text: "Enemies. Which they wish, or may behold, chap. xviii. 31.", attribution: "Calmet" }
    ] },
    { verse: 22, notes: [
      { text: "Head. Or poison, as the Hebrew rosh signifies both.", attribution: "Rondet." }
    ] },
    { verse: 23, notes: [
      { text: "Woman. Greek, \"enemy.\" (Calmet) — Revenge is the passion of little souls, and of women. (Juvenal xiii.) — Dragon. This is not exaggerated, if we reflect on the evils occasioned by Eve, Dalila, Athalia, &c. (Calmet) — \"A woman is the greatest wild-beast.\"", attribution: "Menander" }
    ] },
    { verse: 24, notes: [
      { text: "Sackcloth. And is black when passion bursts forth, though women too frequently conceal their anger to take deeper vengeance.", attribution: "Haydock" }
    ] },
    { verse: 25, notes: [
      { text: "Groaned. Greek, \"shall fall.\" — Little. Greek, \"bitterly.\" He cannot avoid hearing of his wife's misconduct. (Haydock) — She will raise him enemies on all sides.", attribution: "Haydock" }
    ] },
    { verse: 26, notes: [
      { text: "Her. I could wish no greater evil to the worst of enemies, Ecclesiastes vii. 27.", attribution: "Haydock" }
    ] },
    { verse: 27, notes: [
      { text: "Man. He cannot advance. (Calmet) — Semper habet lites.", attribution: "Juvenal vi." }
    ] },
    { verse: 28, notes: [
      { text: "Beauty. Other qualifications of more importance must be regarded. (Haydock) — He should choose one who may be a companion and assistant in domestic concerns.", attribution: "Grotius" }
    ] },
    { verse: 30, notes: [
      { text: "A. Greek, \"If she bring a fortune to her husband,\" (Haydock) she will continually upbraid him with it, and cover him with confusion,", attribution: "Haydock" }
    ] },
    { verse: 29, notes: [
      { text: "(Calmet) — Lay-leadership in spiritual things is so unreasonable, that few heretics will endure it.", attribution: "Worthington" }
    ] },
    { verse: 32, notes: [
      { text: "Happy. A lazy wife will give no content.", attribution: "Haydock" }
    ] },
    { verse: 33, notes: [
      { text: "Die. Eve tempted her husband, and thus we are all involved in sin, 1 Timothy ii. 14.", attribution: "Haydock" }
    ] },
    { verse: 34, notes: [
      { text: "Water. Incontinency, chap. xxvi. 15., and Proverbs v. 15. If water find a hole, it will presently flow away. Women were kept much at home in the East, as they are in many parts of Europe. (Calmet) — Retirement and silence are the characteristics of a wise woman.", attribution: "�schylus, Thebas." }
    ] },
    { verse: 35, notes: [
      { text: "She will. Greek, \"cut her off from thy flesh.\" Grabe and Complutensian add, (Haydock) \"give a bill of divorce or her dowry, and send her away.\"", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
